/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.12",
    versionName: "0.8.0-nightly.2026.10.12",
    versionChannel: "nightly",
    buildDate: "2026-10-12T00:18:56.339Z",
    commitHash: "2a67c8974a2e40c04f31116c3848c88068221831",
};
